import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { NodeFieldLabel } from "@/components/doc/right-sidebar/active-node-style/fields/NodeTextField";
import { GraphExpression } from "@/components/doc/right-sidebar/graph-style/GraphExpression";
import { addGraphExpression } from "@/components/graph/utils";
import { isNodeEditable } from "@/components/tiptap/lock/utils";
import { trackEvent } from "@/utils/trackEvent";

import type { GraphNodeModel } from "@/models/nodes/GraphNodeModel";

type Props = {
  node: GraphNodeModel;
};

export const GraphExpressions = observer(function GraphExpressions({ node }: Props) {
  const { graphExpressionNodes } = node;
  const t = useTranslations("sidebar.activeNode");

  const handleOnAdd = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    addGraphExpression(node);
    trackEvent("graph_add_expression", { source: "button" });
  };

  if (graphExpressionNodes.length === 0) {
    return (
      <NodeFieldLabel
        as="div"
        className="py-0.5 pr-0.5 min-h-[28px] flex-1 min-w-0 shadow-block dark:shadow-block-inverted"
        onClick={isNodeEditable(node) ? handleOnAdd : undefined}
        aria-label={t("fields.graphExpression")}
      />
    );
  }

  const showColorPalette = graphExpressionNodes.some((n) => !n.inlineNode?.isEmpty);

  return (
    <>
      {graphExpressionNodes.map((graphExpressionNode) => (
        <GraphExpression
          key={graphExpressionNode.id}
          node={graphExpressionNode}
          showColorPalette={showColorPalette}
        />
      ))}
    </>
  );
});
